module.exports = __webpack_public_path__ + "static/media/liveFeedmax.9f2452e3.png";